/**
 * Capabilities do canal: governam a UI (docs/09 §3.8) e o comportamento da API.
 * A UI NUNCA assume que todo canal e WhatsApp (RF-UX-120).
 */
import { z } from "zod";
import { channelType } from "./enums.js";

export const CAPABILITY_KEYS = [
  "qr",
  "ack",
  "typing",
  "reactions",
  "templates",
  "media_types",
  "groups",
  "window",
] as const;

export const mediaKind = z.enum([
  "image",
  "video",
  "audio",
  "voice",
  "document",
  "sticker",
  "location",
  "contact",
]);

export const channelCapabilities = z.object({
  qr: z.boolean(),
  ack: z.boolean(),
  typing: z.boolean(),
  reactions: z.boolean(),
  templates: z.boolean(),
  media_types: z.array(mediaKind),
  groups: z.boolean(),
  window: z.boolean(),
});

export type ChannelCapabilities = z.infer<typeof channelCapabilities>;

/**
 * Default por tipo de canal. Hoje so `whatsapp_waha` esta implementado (v1).
 * Tipos futuros entram aqui sem tocar o dominio (docs/14 §10).
 */
export const DEFAULT_CAPABILITIES: Record<z.infer<typeof channelType>, ChannelCapabilities> = {
  whatsapp_waha: {
    qr: true,
    ack: true,
    typing: true,
    reactions: true,
    // Templates sao recurso do WhatsApp OFICIAL (Cloud API); o WAHA nao tem.
    templates: false,
    media_types: ["image", "video", "audio", "voice", "document", "sticker", "location", "contact"],
    groups: true,
    // Sem janela de 24h no canal nao-oficial.
    window: false,
  },
};
